export default __webpack_public_path__ + "static/media/3usps-logo.260998db.png";